import { NOTIFICATION_MAP } from "../constants";
import CustomLink from "../../../../components/Common/buttons/CustomLink";
import msgIcon1 from "../../../../assets/images/svg/msg_icon-1.svg";

const PriceBundleRenderer = ({ notification, classes }) => (
  <div className={classes.msgItem} key={`${notification.id}-${notification.timestamp}`}>
    <img src={msgIcon1} alt="msgIcon" />
    <div className={classes.wrapText}>
      {NOTIFICATION_MAP[notification.action]?.text1 && (
        <CustomLink color="#0085FF" underlined target="_blank" to={`/user/${notification.createdBy}`}>
          {notification.createdBy}
        </CustomLink>
      )}
      {`${NOTIFICATION_MAP[notification.action]?.text1}`}
      <CustomLink
        color="#0085FF"
        underlined
        target="_blank"
        to={NOTIFICATION_MAP[notification.action]?.link(notification.id)}
      >
        {notification[NOTIFICATION_MAP[notification.action]?.key]}
      </CustomLink>
      <span className={classes.actionText}>{NOTIFICATION_MAP[notification.action]?.text2}</span>
    </div>
  </div>
);

export default PriceBundleRenderer;
